import { StateBook } from "../models/books"

export const getBookStateTranslates: { [key in StateBook]: string } = 
{
  'abandoned': 'Abandonado', 
  'read': 'Lido', 
  'reading': 'Lendo', 
  'want': 'Quero Lê'
}

export function getBookStateTranslatesByKey(key: StateBook): string {
  return getBookStateTranslates[key] 
}

export function createArrayOfNumbers(initial: number, final: number, step: number = 1) {
  const arr = [];
  for (let i = initial; i <= final; i += step) {
    arr.push(i);
  }
  return arr;
}

export async function delay(ms: number): Promise<void> {
  await new Promise(resolve => setTimeout(resolve, ms));
}

export function omitKey(key, obj) {
  const { [key]: omitted, ...rest } = obj;
  return rest;
}

export function renameKey(newKey, oldKey, obj) {
  obj[newKey] = obj[oldKey];

  delete obj[oldKey];

  return obj;
}
